// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"58":"f3948ccebccfbbea","671":"d57d71e5032cec46"}[chunkId] + ".js";
};